/**
 * 服务中心路由配置
 * @description 服务中心相关路由
 */
import type { RouteRecordRaw } from 'vue-router'

const serviceCenterRoutes: RouteRecordRaw[] = [
  {
    path: '/service-center',
    component: () => import('@/components/layout/LayoutServiceCenter/LayoutServiceCenter.vue'),
    children: [
      {
        path: 'faqs',
        name: 'ServiceCenterFAQs',
        component: () => import('@/views/serviceCenter/FAQs.vue'),
        meta: {
          title: '常见问题 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 1,
        },
      },
      {
        path: 'guide',
        name: 'ServiceCenterGuide',
        component: () => import('@/views/serviceCenter/Guide.vue'),
        meta: {
          title: '使用指南 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 2,
        },
      },
      {
        path: 'task-publish-guide',
        name: 'ServiceCenterTaskPublishGuide',
        component: () => import('@/views/serviceCenter/TaskPublishGuide.vue'),
        meta: {
          title: '发布任务 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 3,
        },
      },
      {
        path: 'platform-rules',
        name: 'ServiceCenterPlatformRules',
        component: () => import('@/views/serviceCenter/PlatformRules.vue'),
        meta: {
          title: '平台规则 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 4,
        },
      },
      {
        path: 'service-agreement',
        name: 'ServiceCenterServiceAgreement',
        component: () => import('@/views/serviceCenter/ServiceAgreement.vue'),
        meta: {
          title: '服务协议 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 5,
        },
      },
      {
        path: 'copyright-notice',
        name: 'ServiceCenterCopyrightNotice',
        component: () => import('@/views/serviceCenter/CopyrightNotice.vue'),
        meta: {
          title: '版权声明 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 6,
        },
      },
      {
        path: 'trade-terms',
        name: 'ServiceCenterTradeTerms',
        component: () => import('@/views/serviceCenter/TradeTerms.vue'),
        meta: {
          title: '交易条款 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 7,
        },
      },
      {
        path: 'online-service',
        name: 'ServiceCenterOnlineService',
        component: () => import('@/views/serviceCenter/OnlineService.vue'),
        meta: {
          title: '在线客服 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 8,
        },
      },
      {
        path: 'complaint-feedback',
        name: 'ServiceCenterComplaintFeedback',
        component: () => import('@/views/serviceCenter/ComplaintFeedback.vue'),
        meta: {
          title: '投诉反馈 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 9,
        },
      },
      {
        path: 'product-suggestion',
        name: 'ServiceCenterProductSuggestion',
        component: () => import('@/views/serviceCenter/ProductSuggestion.vue'),
        meta: {
          title: '产品建议 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 10,
        },
      },
      {
        path: 'contact',
        name: 'ServiceCenterContactInfo',
        component: () => import('@/views/serviceCenter/ContactInfo.vue'),
        meta: {
          title: '联系方式 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          order: 12,
        },
      },
      {
        path: 'manufacturers',
        name: 'ServiceCenterManufacturers',
        component: () => import('@/views/serviceCenter/Manufacturers/index.vue'),
        meta: {
          title: '认证厂商 - 服务中心',
          requiresAuth: false,
          cache: true,
          breadcrumb: true,
          order: 13,
        },
      },
      {
        path: 'manufacturers/:id',
        name: 'ServiceCenterManufacturerDetail',
        component: () => import('@/views/serviceCenter/Manufacturers/Detail.vue'),
        meta: {
          title: '厂商详情 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          hideInMenu: true,
        },
      },
      {
        path: 'activities',
        name: 'ServiceCenterActivities',
        component: () => import('@/views/serviceCenter/Activities/index.vue'),
        meta: {
          title: '活动中心 - 服务中心',
          requiresAuth: false,
          cache: true,
          breadcrumb: true,
          order: 14,
        },
      },
      {
        path: 'activities/:id',
        name: 'ServiceCenterActivityDetail',
        component: () => import('@/views/serviceCenter/Activities/Detail.vue'),
        meta: {
          title: '活动详情 - 服务中心',
          requiresAuth: false,
          cache: false,
          breadcrumb: true,
          hideInMenu: true,
        },
      },
    ],
  },
]

export default serviceCenterRoutes
